import React, { useEffect, useRef, useState } from 'react';
import { type Editor } from 'slate';
import styles from '../../../components/Toolbar/Toolbar.module.css';
import ColorPicker from '../../../components/ColorPicker/ColorPicker';
import { ReactEditor } from 'slate-react';
import ColorUtils from '../../../util/color';
import { svgToIcon } from '../../../components/Toolbar/toolbarUtils';
import alternateRowsSvg from '../../../assets/icons/alternateRows.svg';

interface TableAlternateRowColorToolbarComponentProps {
  editor: Editor;
  getRowColor: () => string | undefined;
  setRowColor: (color?: string) => void;
  active?: boolean;
  enabled?: boolean;
}

const TableAlternateRowColorToolbarComponent: React.FC<
  TableAlternateRowColorToolbarComponentProps
> = ({ editor, getRowColor, setRowColor, active, enabled }) => {
  const menuRef = useRef<HTMLElement>();
  const [currentColor, setCurrentColor] = useState(getRowColor());

  useEffect(() => {
    setCurrentColor(getRowColor());
  }, [editor, editor.selection]);

  const handleColorChange = (color: string, focusEditor?: boolean) => {
    const mappedColor = ColorUtils.mapColorFromColorPickerFromDarkMode(color);

    setRowColor(mappedColor);
    setCurrentColor(mappedColor);

    if (focusEditor) {
      ReactEditor.focus(editor);
    }
  };

  const handleClearColor = () => {
    setRowColor();
    setCurrentColor(undefined);
    ReactEditor.focus(editor);
  };

  return (
    <aha-menu ref={menuRef}>
      <div slot="control">
        <div
          className={styles.toolbarButton}
          aria-selected={active}
          aria-disabled={!enabled}
        >
          <span className={styles.alternateRowColorIcon}>
            {svgToIcon(alternateRowsSvg)}
            <span className={styles.alternateRowColorCircle}>
              <span
                className={styles.alternateRowColorCircleInner}
                style={currentColor ? { backgroundColor: currentColor } : {}}
              />
            </span>
          </span>
        </div>
      </div>
      <aha-menu-content>
        <ColorPicker
          currentColor={currentColor ?? '#ffffff'}
          handleColorChange={handleColorChange}
          handleClearColor={handleClearColor}
          handleCloseMenu={() => menuRef.current?.removeAttribute('open')}
          showCustomColorInput
          showClearButton
        />
      </aha-menu-content>
    </aha-menu>
  );
};

export default TableAlternateRowColorToolbarComponent;
